import ValidatedNode from "./ValidatedNode";

export default {
  ValidatedNode
};
